import { createAction, props } from "@ngrx/store";
import { SupplierTaxInfo } from "../../models/tax.model";
import { CompleteRegistration, FormTemplate, OnboardingAddressDetails, OnboardingDocumentInformation, OnboardingTrainingDocument } from "../../models/onboarding.model";
import { SupplierAddress, SupplierBank, SupplierContact } from "../../models/supplier.model";

export const SetCurrentSupplierCode = createAction(
    '[Onboarding] Set Current Supplier Code',
    props<{ supplierCode: string }>()
);

export const SetSupplierType = createAction(
    '[Onboarding] Set Supplier Type',
    props<{ supplierType: string }>()
);

export const SetSupplierCategory = createAction(
    '[Onboarding] Set Supplier Category',
    props<{ supplierCategory: number }>()
);

export const SetVendorCountry = createAction(
    '[Onboarding] Set Vendor Country',
    props<{ vendorCountry: string }>()
);

export const SetSupplierCodes = createAction(
    '[Onboarding] Set Supplier Codes',
    props<{ supplierCodes: Array<string> }>()
);

export const SetErrorMessage = createAction(
    '[Onboarding] Set Error Message',
    props<{ errorMessage: string }>()
);

export const SetRegionCode = createAction(
    '[Onboarding] Set Region Code',
    props<{ regionCode: string }>()
);

export const SetSupplierDetails = createAction(
    '[Onboarding] Set Supplier Details',
    props<{ supplierLegalName: string, supplierDbaName: string }>()
);

export const SetSupplierAddress = createAction(
    '[Onboarding] Set Supplier Address',
    props<{ supplierAddress: OnboardingAddressDetails }>()
);

export const SetSupplierContacts = createAction(
    '[Onboarding] Set Supplier Contacts',
    props<{ contacts: SupplierContact[] }>()
);

export const SetSupplierBank = createAction(
    '[Onboarding] Set Supplier Bank',
    props<{ supplierBank: SupplierBank }>()
);

export const SetSupplierTax = createAction(
    '[Onboarding] Set Supplier Tax',
    props<{ supplierTax: SupplierTaxInfo }>()
);

export const SetDocumentInformation = createAction(
    '[Onboarding] Set Onboarding Document Information',
    props<{ documentInfo: OnboardingDocumentInformation }>()
);

export const SetCompleteRegistration = createAction(
    '[Onboarding] Set Complete Registration',
    props<{ completeRegistration: CompleteRegistration }>()
);

export const SetOnboardingClmFlag = createAction(
    '[Onboarding] Set Onboarding Clm Flag',
    props<{ flag: boolean }>()
);

export const GetExtendedOnboardingTrainingDocuments = createAction(
    '[Onboarding] Get Extended Training Documents',
);

export const GetInitialOnboardingTrainingDocuments = createAction(
    '[Onboarding] Get Extended Training Documents',
);

export const GetOnboardingTrainingDocumentsSuccess = createAction(
    '[Onboarding] Get Training Documents Success',
    props<{ onboardingType: 'extended' | 'initial', documents: OnboardingTrainingDocument[] }>()
);

export const SetEhsQuestionnaireResponse = createAction(
    '[Onboarding] Set EHS Questionnaire',
    props<{ response: any }>()
);